import React, { Component } from 'react';

import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { array, arrayOf, bool, eventListener, oneOfType } from '@philips-emr/tws-core/lib/component/prop-types';
import { difference } from '@philips-emr/tws-utils';

import { HpmsGuiaAnaliseApi } from '../../api';

import HpmsGuiaAnaliseCard from './hpms-guia-analise-card';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: HpmsGuiaAnaliseApi })
export default class HpmsGuiaAnaliseItens extends Component {

  static propTypes = {
    data: arrayOf(oneOfType([array])).notEnumerable(),
    hiddenContextMenu: bool,
    onInformarParecerClick: eventListener,
    readonly: bool,
  };

  static defaultProps = {
    data: [],
  };

  state = {
    record: {},
  };

  componentDidUpdate(oldProps) {
    const { data: oldData } = oldProps;
    const { data } = this.props;

    if (Array.isArray(data) && difference(data, Array.isArray(oldData) ? oldData : []).length > 0) {
      const record = data.reduce((accumulator, item) => {
        return { ...accumulator, [item.nrSequencia]: item };
      }, {})

      this.setState({ record });
    }
  }

  onChange = ({ entry, value }) => {
    const { record } = this.state;
    let newRecord = { ...record, [entry]: value };

    this.setState({ record: newRecord });
  }

  renderCard(item) {
    const { onInformarParecerClick, readonly, hiddenContextMenu } = this.props;

    return <HpmsGuiaAnaliseCard
      key={item.nrSequencia}
      value={item}
      onChange={this.onChange}
      onInformarParecerClick={onInformarParecerClick}
      readonly={readonly}
      hiddenContextMenu={hiddenContextMenu}
    />;
  }

  render() {
    const { record } = this.state;

    return Object.entries(record).map(([, value]) => this.renderCard(value));
  }
}
